import React, { useState } from 'react'
import { CallToAction } from '../CallToAction'
import { mergeClassList } from '../../lib/utils'

export const NewsletterTutorial = ({
    compact = false,
    bgColor = '#08042f',
    className = '',
}: {
    compact?: boolean
    bgColor?: string
    className?: string
}): JSX.Element => {
    const [email, setEmail] = useState('')
    const classList = mergeClassList('mx-auto w-full md:w-auto pt-4 pb-6 relative z-10', className)

    return compact ? (
        <div className="mx-auto my-12 w-full text-center">
            <div className="flex h-full w-full border-t border-b border-dashed border-gray-accent-light p-1 dark:border-gray-accent-dark">
                <div className={classList}>
                    <div className="flex flex-col items-center space-x-4 md:flex-row">
                        <figure className="m-0 shrink-0 grow-0 basis-12  dark:text-white">
                            <svg
                                className="mb-0 block h-12 fill-current"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                                viewBox="0 0 50 50"
                            >
                                <path
                                    d="M41.5 7.5c-3.86 0-7 3.14-7 7s3.14 7 7 7 7-3.14 7-7-3.14-7-7-7Z"
                                    fill="#0097c2"
                                />
                                <path d="M41.5 23.5c.34 0 .67-.02 1-.06V36.5c0 1.654-1.346 3-3 3h-32c-1.654 0-3-1.346-3-3v-20c0-1.654 1.346-3 3-3h25.06c-.04.33-.06.66-.06 1 0 2.125.74 4.074 1.97 5.615l-8.849 8.85a3.005 3.005 0 0 1-4.244 0l-11.172-11.17a1 1 0 1 0-1.414 1.414l11.17 11.17a4.984 4.984 0 0 0 3.535 1.46c1.28 0 2.56-.484 3.535-1.46l8.85-8.85A8.987 8.987 0 0 0 41.5 23.5Z" />
                            </svg>
                        </figure>

                        <span className="flex flex-grow flex-col space-x-2 font-bold md:flex-row md:justify-start md:text-left">
                            <span className="text-lg">Want more tips?</span>{' '}
                            <span className="text-sm md:text-lg">Get them delivered twice a month.</span>
                        </span>
                    </div>
                    <div className="mt-2 md:ml-16 md:mt-0">
                        <form
                            action="https://icloudready.us19.list-manage.com/subscribe/post?u=292207b434c26e77b45153b96&id=97194afa0a"
                            method="post"
                            id="mc-embedded-subscribe-form"
                            name="mc-embedded-subscribe-form"
                            className="validate mb-0 flex w-full flex-col items-center space-y-2 md:flex-row md:space-y-0 md:space-x-2"
                            target="_blank"
                            noValidate
                        >
                            <input
                                type="email"
                                name="EMAIL"
                                className="block w-full max-w-sm flex-1 rounded-md border-0 bg-white px-4 py-2 text-center text-lg font-bold outline-none dark:bg-gray-accent-dark md:text-left md:text-[18px]"
                                id="mce-EMAIL"
                                onChange={(e) => setEmail(e.target.value)}
                                placeholder="email@address.com"
                                value={email}
                                required
                            />
                            {/* real people should not fill this in and expect good things - do not remove this or risk form bot signups*/}
                            <div style={{ position: 'absolute', left: '-5000px' }} aria-hidden="true">
                                <input
                                    type="text"
                                    name="b_292207b434c26e77b45153b96_97194afa0a"
                                    tabIndex={-1}
                                    defaultValue
                                />
                            </div>
                            <input
                                type="submit"
                                className="dark: w-full shrink-0 grow-0 basis-auto cursor-pointer rounded-sm border-none bg-red px-5 py-3 text-lg font-bold text-white dark:bg-white md:w-auto md:py-2 lg:mt-0"
                                value="Sign me up!"
                            />
                        </form>
                    </div>
                </div>
            </div>
        </div>
    ) : (
        <div className="mx-auto mb-48 w-11/12 max-w-4xl">
            <div className="h-full w-full rounded-xl bg-blue p-1 text-white">
                <div
                    className="relative z-10 flex flex-col justify-between rounded-lg p-8 lg:flex-row"
                    style={{ backgroundColor: bgColor }}
                >
                    <div className="w-full text-white lg:mr-4 lg:w-2/3">
                        <h5 className="gosha text-3xl text-white">Your inbox but better...</h5>
                        <p className="text-sm opacity-80">
                            Our newsletter keeps you up to date on what great things we are doing here at iCloudReady,
                            and trust me you don’t want to miss a thing.
                        </p>
                        <p className="mt-2 text-sm opacity-80">
                            Don't worry, you can unsubscribe at any time, no hard feelings.
                        </p>
                    </div>

                    <div className="w-full lg:ml-4 lg:w-1/3">
                        <form
                            action="https://icloudready.us19.list-manage.com/subscribe/post?u=292207b434c26e77b45153b96&id=97194afa0a"
                            method="post"
                            id="mc-embedded-subscribe-form"
                            name="mc-embedded-subscribe-form"
                            className="validate"
                            target="_blank"
                            noValidate
                        >
                            <div id="mc_embed_signup_scroll">
                                <strong className="gosha text-lg text-white">Join our newsletter</strong>
                                <label className="mt-3 block text-white opacity-80" htmlFor="mce-EMAIL">
                                    Email address
                                </label>
                                <input
                                    type="email"
                                    name="EMAIL"
                                    className="text-gray-900 my-1 block w-full rounded bg-white py-2 px-3"
                                    id="mce-EMAIL"
                                    onChange={(e) => setEmail(e.target.value)}
                                    placeholder="Email address"
                                    value={email}
                                    required
                                />
                                {/* real people should not fill this in and expect good things - do not remove this or risk form bot signups*/}
                                <div style={{ position: 'absolute', left: '-5000px' }} aria-hidden="true">
                                    <input
                                        type="text"
                                        name="b_292207b434c26e77b45153b96_97194afa0a"
                                        tabIndex={-1}
                                        defaultValue
                                    />
                                </div>
                                <div className="clear">
                                    <CallToAction
                                        type="primary"
                                        icon="check"
                                        width="full"
                                        className="mt-2 border-2 border-white text-white hover:bg-white hover:bg-opacity-20"
                                        submit={true}
                                    >
                                        Join the List
                                    </CallToAction>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    )
}
